class Monitoring.Methods.RelatedQueryBuilder

  constructor: (searchQuery) ->
    @query = searchQuery.deepCopy()

  getQuery: (model) ->
    if model.subType() == Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReviewContent.SUB_TYPE
      @gmbQueryBuilder(model)
    else
      @defaultQueryBuilder(model)
    @query.addDateTo(Date.now())
    return @query

  gmbQueryBuilder: (model) ->
    @query.addGMBParentReviewId(model._getContent().getReviewId())
    @query.removeDateFromRealtime()

  defaultQueryBuilder: (model) ->
    if model.subType() == 'fb-comment'
      @query.setParentCommentId(model.contentId())
    else if model.subType() == 'fb-post'
      @query.addParentPostId(model.contentId())
    else if model.type() == 'instagramMedia'
      @query.addParentId(model.getRootParentId())
    else if model.subType() == 'yt-comment'
      @query.addParentPostId(model.parentPostId())
    else if model.type() == 'tiktok'
      @query.addChildCommentsFor(model.rootPostId())
      @query.addSubtype('tiktok-comment')
    else
      @query.addChildCommentsFor(model.cassandra_id())
    @query.removeDateFromRealtime()
    @query.addDateFrom(Date.create(model.created_at()))
